module.exports = __webpack_public_path__ + "img/AppStoreDown.96bdb0b4.jpg";